"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventDuplicate = void 0;
function isEventDuplicate(first, second, _a) {
    var ignoredKeys = _a.ignoredKeys, deduplicator = _a.deduplicator;
    if (deduplicator && deduplicator(first, second)) {
        return true;
    }
    var replacer = function (key, value) { return (ignoredKeys.includes(key) ? undefined : value); };
    return JSON.stringify(first, replacer) === JSON.stringify(second, replacer);
}
exports.isEventDuplicate = isEventDuplicate;
